// services/v3/cache/entityCache.ts — EntityCache over the kv store (SPEC §5)
import type { CacheEntry, EntityCache } from '~/types/v3/cache'
import { kvDel, kvGet, kvKeys, kvSet } from './idb'

function isCacheEntry(v: unknown): v is CacheEntry<unknown> {
  if (typeof v !== 'object' || v === null) return false
  const e = v as Record<string, unknown>
  return typeof e.version === 'string' && typeof e.fetchedAt === 'number' && 'data' in e
}

export const entityCache: EntityCache = {
  async get<T>(key: string): Promise<CacheEntry<T> | undefined> {
    const raw = await kvGet<unknown>(key)
    if (!isCacheEntry(raw)) return undefined
    return raw as CacheEntry<T>
  },

  async set<T>(key: string, e: CacheEntry<T>): Promise<void> {
    await kvSet(key, e)
  },

  async del(key: string): Promise<void> {
    await kvDel(key)
  },

  /** Deletes every key starting with `v3:${storeId}:` (settings, products, channel_price, profile, menuSet:*). */
  async clearStore(storeId: string): Promise<void> {
    const prefix = `v3:${storeId}:`
    const all = await kvKeys()
    for (const k of all) {
      if (k.startsWith(prefix)) await kvDel(k)
    }
  },
}

export default entityCache
